import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import closeIcon from '../Assets/images/close_red.png';
import BiztantuLoader from './Loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LeadDialog = ({checked, open, handleClose, handleSave,selectionModel,  title, alternateBtnLabel = "", children, size, btnlabel,autoFocusBtn = false, btnSize = "medium", paperProps,
  btnlabel2,handleSave2=()=>{}, hideActions = false

 }) => {
  const isLoading = useSelector(state => state?.global?.isDialogLoading);

  return (
    <div>
       <Dialog
          fullWidth={true}
          maxWidth= {size}
          open={open}
          onClose={handleClose}
          disableRestoreFocus 
          PaperProps={paperProps}
      >
        <BiztantuLoader open={isLoading} isChildren>
        <DialogTitle style={{display: "flex", alignItems:'center', justifyContent: "space-between", padding: "10px"}}>
            <Typography variant='h6' gutterBottom>
              {title}
            </Typography>
            <IconButton onClick={handleClose}>
              <img src={closeIcon} style={{height: "35px",}}/>
            </IconButton>
        </DialogTitle>
        
        <DialogContent className = "custom-dialog-content" dividers>
          {children}
        </DialogContent>
        {!hideActions && <DialogActions>
          <Stack display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} flexDirection={"row"}>
           { btnlabel &&
            <Button size={btnSize} className="edit-primary mr-20 btn-search" disabled={checked ? selectionModel?.length === 0 : false} autoFocus={autoFocusBtn} onClick={handleSave}>
              {btnlabel}
            </Button>
}
{ btnlabel2 &&
            <Button size={btnSize} className="edit-primary mr-20 btn-search" disabled={checked ? selectionModel?.length === 0 : false} autoFocus={autoFocusBtn} onClick={handleSave2}>
              {btnlabel2}
            </Button>
}
          {alternateBtnLabel && <Button className="edit-primary ml-20 btn-search reset-btn"  onClick={handleClose}>
            {alternateBtnLabel}
          </Button>
        }
        </Stack>
          
        </DialogActions>}
        
        </BiztantuLoader>
      </Dialog>
    </div>
  );
}

export default LeadDialog;
